import { render, staticRenderFns } from "./ModifyInformation.vue?vue&type=template&id=e20ab988&"
import script from "./ModifyInformation.vue?vue&type=script&lang=js&"
export * from "./ModifyInformation.vue?vue&type=script&lang=js&"
import style0 from "./ModifyInformation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports